import * as client from "../../../client";
// From the generated schemas module directly so this file stays importable
// from unit tests (the client barrel pulls in axios).
import { $ReinsurerInfo } from "../../../client/schemas.gen";

export type ValuationType = NonNullable<
  client.ValuationInfo[keyof client.ValuationInfo]
>;

// Valuation type options per group, matching the Policy Fly proto enums
export const PHYSICAL_VALUATION_TYPE_1_OPTIONS: ValuationType[] = [
  "Excluded",
  "Actual Cash Value",
  "Replacement Cost",
  "Functional Replacement Cost",
] as const;

export const PHYSICAL_VALUATION_TYPE_2_OPTIONS: ValuationType[] = [
  "Excluded",
  "Actual Cash Value",
  "Replacement Cost",
  "Selling Price",
] as const;

export const BI_VALUATION_TYPE_OPTIONS: ValuationType[] = [
  "Excluded",
  "Actual Loss Sustained",
] as const;

export const EQUIPMENT_VALUATION_TYPE_OPTIONS: ValuationType[] = [
  "Excluded",
  "Actual Cash Value",
  "Replacement Cost",
  "Agreed Value",
  "Actual Cash Value, except Replacement cost if newer than 5 years old",
] as const;

// One entry per valuation_info field, in display order, with the label the
// General tab and the policy workspace both use.
export const VALUATION_FIELDS: {
  key: keyof client.ValuationInfo;
  label: string;
  options: ValuationType[];
}[] = [
  {
    key: "physical_valuation_type_1",
    label: "Physical (Buildings, BPP, Contents, etc.)",
    options: PHYSICAL_VALUATION_TYPE_1_OPTIONS,
  },
  {
    key: "physical_valuation_type_2",
    label: "Stock / Inventory (Stock, Inventory, Outdoor, etc.)",
    options: PHYSICAL_VALUATION_TYPE_2_OPTIONS,
  },
  {
    key: "bi_valuation_type",
    label: "Business Income / Extra Expense",
    options: BI_VALUATION_TYPE_OPTIONS,
  },
  {
    key: "equipment_valuation_type",
    label: "Equipment (Contractors, Mobile)",
    options: EQUIPMENT_VALUATION_TYPE_OPTIONS,
  },
];

// The backend's default split, read from the OpenAPI schema; shown (and saved)
// for reports created before reinsurer percentages were stored on the report.
export const DEFAULT_REINSURER_INFO: client.ReinsurerInfo = {
  ren_percentage: $ReinsurerInfo.properties.ren_percentage.default,
  nephila_percentage: $ReinsurerInfo.properties.nephila_percentage.default,
  starr_percentage: $ReinsurerInfo.properties.starr_percentage.default,
};

export const REINSURER_FIELDS: {
  key: keyof client.ReinsurerInfo;
  label: string;
}[] = [
  { key: "ren_percentage", label: "RenaissanceRe" },
  { key: "nephila_percentage", label: "Nephila" },
  { key: "starr_percentage", label: "Starr" },
];

export const EMPTY_POLICY_INFO: client.PolicyInfo = {
  included_perils: [],
  selected_policy_form_name: null,
};
